import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { closeShadingMenu, toggleAdjustShadingWarningModal, toggleShadingMenu } from 'store/slices/AdjustShadingSlice';
import ConfirmationModal from 'components/Basic/Modal/Confirmation';

export default function AdjustShadingWarningModal() {
	const { shadingWarningModal: { open, warningMessage } } = useSelector((state: RootState) => state.adjustShadingState.data);
	const dispatch = useDispatch();

	function handleConfirmation() {
		(document.activeElement as HTMLElement)?.blur();
		dispatch(closeShadingMenu());
		dispatch(toggleAdjustShadingWarningModal({
			open: false,
			warningMessage: '',
		}));
	}

	function closeModal() {
		(document.activeElement as HTMLElement)?.blur();
		dispatch(toggleShadingMenu({ open: true }));
		dispatch(toggleAdjustShadingWarningModal({
			open: false,
			warningMessage: '',
		}));
	}

	return (
		<ConfirmationModal
			open={open}
			onConfirm={handleConfirmation}
			onCancel={closeModal}
			message={warningMessage}
		/>
	);
}
